import { breakpoint, styled } from '../styled-components'
import { Utils } from '../Utils'

export const ButtonBar = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px 20px 0 20px;
  ${breakpoint('tablet')`
    padding: 15px 0 0 0;
    flex-direction: row;
  `}
`

export const Button = styled.a<{ primary?: boolean; disabled?: boolean; small?: boolean; fullWidth?: boolean }>`
  display: block;
  text-decoration: none;
  cursor: pointer;
  border-radius: 5px;
  line-height: ${(props) => (props.small ? '36px' : '50px')};
  padding: 0 ${(props) => (props.small ? '20px' : '35px')};
  font-size: ${(props) => (props.small ? '14px' : '20px')};
  text-align: center;
  color: white;
  background: ${(props) => (props.primary ? props.theme.primaryColor : props.theme.textColor)};
  ${(props) => props.disabled && 'opacity: 0.36;'};
  ${(props) => props.fullWidth && 'width: 100%;'};
  outline: none;
  border: none;
  margin-bottom: 5px;
  ${breakpoint('tablet')`
    margin-bottom: 0
  `}
  &:last-child {
    margin-bottom: 0;
  }
`

export const NextButton = styled(Button)`
  display: block;
  background-image: url(${Utils.getAssetPath('/assets/icons/arrow-right-white.svg')});
  background-repeat: no-repeat;
  background-position: 90% center;
  padding: 0 50px 0 20px;
`

export const LoadMoreButton = styled(Button)`
  display: inline-block;
  margin: auto;
  background: ${(props) => props.theme.primaryColor};
  background-image: url(${Utils.getAssetPath('/assets/icons/arrow-down-white.svg')});
  background-repeat: no-repeat;
  background-position: 90% center;
  padding: 0 50px 0 20px;
`
